import { render, staticRenderFns } from "./IsolationCard.vue?vue&type=template&id=95afa384"
import script from "./IsolationCard.vue?vue&type=script&lang=js"
export * from "./IsolationCard.vue?vue&type=script&lang=js"
import style0 from "./IsolationCard.vue?vue&type=style&index=0&id=95afa384&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports